import { isMessageSmbReply } from 'util/messageUtil';
import * as sources from 'constants/sources';
import { isValidPartnerReachOutTicket } from './ticketSelector';

export const getMessageAvatar = (message, ticketId) => {
  if (isMessageSmbReply(message)) {
    return '/images/avatars/partners/partner-avatar.svg';
  } else if (message.source === sources.SMB_BOT) {
    return '/images/avatars/partners/partner-bot-avatar.svg';
  } else if (message.direction === 'INBOUND') {
    return getCustomerAvatar({ ticketId });
  }

  if (message.expert?.isAdmin) {
    return '/images/avatars/experts/specialist-avatar.svg';
  }

  return '/images/avatars/experts/expert-avatar.svg';
};

export const getCustomerAvatar = (ticket) => {
  if (!ticket.ticketId) {
    return '/images/avatars/customers/customer-avatar-error.svg'; // empty placeholder images
  }
  if (isValidPartnerReachOutTicket(ticket)) {
    return '/images/avatars/customers/customer-avatar-cash-back.svg';
  }
  const firstCharacter = ticket.ticketId.slice(0, 1);
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let avatarNumber = chars.indexOf(firstCharacter);
  avatarNumber = avatarNumber === -1 ? 63 : avatarNumber + 1;

  return `/images/avatars/customers/customer-avatar-${avatarNumber}.svg`;
};
